"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var HttpTypeService = /** @class */ (function () {
    function HttpTypeService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
    }
    HttpTypeService_1 = HttpTypeService;
    HttpTypeService.prototype.getTypes = function () {
        var _this = this;
        return this.applicationPropertiesService
            .getProperty(HttpTypeService_1.serviceUrlKey)
            .then(function (serviceUrl) {
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            return _this.http.get(serviceUrl + HttpTypeService_1.typesApiUrlEndpoint, { headers: headers }).map(function (response) {
                return response.map(function (item) {
                    return { id: item.id, name: item.name };
                });
            }).toPromise();
        });
    };
    HttpTypeService.serviceUrlKey = 'ml-service-url';
    HttpTypeService.typesApiUrlEndpoint = '/types';
    HttpTypeService = HttpTypeService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpTypeService);
    return HttpTypeService;
    var HttpTypeService_1;
}());
exports.HttpTypeService = HttpTypeService;
//# sourceMappingURL=http-type.service.js.map